import { request } from './client';

export const apiAdminGetPaymentConfig = () => request('/admin/payment-config');
export const apiAdminUpdatePaymentConfig = (body) =>
  request('/admin/payment-config', { method: 'PUT', body });
